<template>
  <div :class="topClass">
    KPLH
    <div :class="className">
      <label
        class="flex-row items-center"
        v-for="(list, index) in kplhCategories"
        :key="index"
      >
        <input
          v-model="chooseKplhScore"
          type="checkbox"
          :value="list.id"
          style="margin-right: 10px"
        />
        {{ list.desc }}
      </label>
    </div>
  </div>
</template>
<script>
export default {
  props: ['className', 'topClass'],
  computed: {
    kplhCategories() {
      return this.$store.state.kplhCategories
    },
    chooseKplhScore: {
      get: function() {
        return this.$store.state.searchStore.chooseKplhScore
      },
      set: function(newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'chooseKplhScore',
          value: newValue,
        })
      },
    },
  },
}
</script>
